import { QUERY_KEY as DIFF_QUERY_KEY } from '~/app/features/Gallery/queries/queryBatchDifferentialPricing'
import { UseQueryResult, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { queryBatchEstimatedPricing } from '~/app/features/Gallery/queries/queryBatchEstimatedPricing'
import type { PCT } from 'shared/types/vp/pct'

type EstimatedKey = PCT.Queries.ProductCatalogPricingService.QuantitiesPriceQueryKey
type EstimatedResult = PCT.Models.ProductCatalogPricingService.QuantitiesPricingResult | null

export const useBatchEstimatedPricing = (
  params: PCT.Queries.ProductCatalogPricingService.QuantitiesPriceQueryKeyParameters,
  options?: Omit<UseQueryOptions<EstimatedResult, Error, EstimatedResult, EstimatedKey>, 'queryKey'>,
): UseQueryResult<PCT.Models.ProductCatalogPricingService.QuantitiesPricingResult | null | undefined> =>
  useQuery({
    queryKey: [
      DIFF_QUERY_KEY,
      {
        ...params,
      },
    ],
    queryFn: queryBatchEstimatedPricing,
    ...options,
  })
